import { RealtySource } from 'shared/api/kyrgyzstan/search/model'

export type ContactPersonField =
  'lastName' | 'firstName' | 'middleName' | 'email' | 'phone'

export type ContactPersonValidation = 'email' | 'phone'
export type ContactPersonFieldType = 'text' | 'phone'

interface BaseContactPersonFieldConfig {
  name: ContactPersonField
  type: ContactPersonFieldType
  required: boolean
  validation?: ContactPersonValidation
}

export interface PhoneContactPersonFieldConfig extends BaseContactPersonFieldConfig {
  name: 'phone'
  type: 'phone'
  validation: 'phone'
}

export interface TextContactPersonFieldConfig extends BaseContactPersonFieldConfig {
  name: Exclude<ContactPersonField, 'phone'>
  type: 'text'
  inputType?: 'email' | 'text'
  validation?: 'email'
}

export type ContactPersonFieldConfig =
  PhoneContactPersonFieldConfig | TextContactPersonFieldConfig

export interface ContactPersonConfig {
  fields: ContactPersonFieldConfig[]
}

const defaultContactPersonConfig: ContactPersonConfig = {
  fields: [
    {
      name: 'firstName',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      type: 'phone',
      required: true,
      validation: 'phone',
    },
  ],
}

const exelyContactPersonConfig: ContactPersonConfig = {
  fields: [
    {
      name: 'lastName',
      type: 'text',
      required: true,
    },
    {
      name: 'firstName',
      type: 'text',
      required: true,
    },
    {
      name: 'email',
      type: 'text',
      inputType: 'email',
      required: true,
      validation: 'email',
    },
    {
      name: 'phone',
      type: 'phone',
      required: true,
      validation: 'phone',
    },
  ],
}

const contactPersonConfigBySource: Partial<
  Record<RealtySource, ContactPersonConfig>
> = {
  [RealtySource.EXELY]: exelyContactPersonConfig,
}

export const getContactPersonConfig = (
  source?: RealtySource,
): ContactPersonConfig =>
  source
    ? (contactPersonConfigBySource[source] ?? defaultContactPersonConfig)
    : defaultContactPersonConfig
